import "./PersonalInfo.css";
import React, { useContext } from "react";
import FormState from "../context/FormState";
import styles from "./personalInfo.module.css";
import logo from "../../../assets/img/logo.png";
import Profile_img from "../../../assets/img/Profile_img.png";
function EduInfo(props) {
  const ctx = useContext(FormState);
  const submithandler = () => {};
  return (
    <React.Fragment>
    {/* <Header></Header> */}

    <div className={styles.container}>
      <div className={styles.left}>
        <div className={styles.imageContainer}>
          <img src={logo} alt="" />

          <div className={styles.logoDesc}>
            <p>VIT AP UNIVERSITY</p>
            <p className={styles.smallDes}>Alumni Association</p>
          </div>
        </div>

        {/* image kindha */}
        <div className={styles.sideNav}>
                  <div className={styles.navItem}>
                    <div className={styles.num}>1</div>
                    <div className={styles.pInfo}>
                      <p className={styles.pBigInfo}>Personal Information</p>
                      <p className={styles.psmallInfo}>Personal Profile Details</p>
                    </div>
                  </div>
      
                  <div className={styles.navItem}>
                    <div className={styles.num}>2</div>
      
                    <div className={styles.pInfo}>
                      <p className={styles.pBigInfo}>Educational Information</p>
                      <p className={styles.psmallInfo}>Courses/degrees pursued</p>
                    </div>
                  </div>
      
                  <div className={styles.navItem} style={{"opacity":"0.6"}}>
                    <div className={styles.num}>3</div>
      
                    <div className={styles.pInfo}>
                      <p className={styles.pBigInfo}>Contact Details</p>
                      <p className={styles.psmallInfo}>Location and contact</p>
                    </div>
                  </div>
      
                  <div className={styles.navItem} style={{"opacity":"0.6"}}>
                    <div className={styles.num}>4</div>
      
                    <div className={styles.pInfo}>
                      <p className={styles.pBigInfo}>Work Details</p>
                      <p className={styles.psmallInfo}>Professional Details</p>
                    </div>
                  </div>
                </div>
      </div>

      <div className={styles.right}>
        <div className={styles.profile}>
          <div className={styles.userInfo}>
            <p className={styles.username}>Mervin Joseph</p>
            <p>VIT AP University</p>
          </div>
          <img
            src={Profile_img}
            alt="Profile Image"
            className={styles.profileImage}
          />
        </div>

        <h1>Educational Information</h1>

        <div className={styles.rightDesc}>
          <div className={styles.rightItems}>
            <p>University</p>

            <div className={styles.radionCon}>
              <input type="radio" /> Mr
              <input type="radio" /> Ms
              <input type="radio" /> Dr
              <input type="radio" /> Prof
              <input type="radio" /> Other
            </div>
          </div>

          <div className={styles.rightItems}>
            <p>Degree</p>
            <div className={styles.radionCon}>
              <input
                className={styles.name}
                type="text"
                placeholder="FirstName"
              />
              <input
                className={styles.name}
                type="text"
                placeholder="Middle Name"
              />
              <input
                className={styles.name}
                type="text"
                placeholder="Last Name"
              />
            </div>
          </div>

          <div className={styles.rightItems}>
            <p>Graduation Year</p>
            <div className={styles.radionCon}>
              <input type="radio" /> Male
              <input type="radio" /> Female
              <input type="radio" /> Prefer not to disclose
            </div>
          </div>

          <div className={styles.rightItems}>
            <p>Registration No</p>
            <div className={styles.radionCon}>
              <input type="text" />
            </div>
          </div>
        </div>

        {/* buttons */}
        <div className={styles.buttons}>
          <button className={styles.btn} onClick={ ()=>props.setStep("2")}>Back</button>
          <button className={styles.btn} onClick={()=> props.setStep("4")}>Next</button>
        </div>
      </div>
    </div>
  </React.Fragment>
  );
}
export default EduInfo;
